import { View } from "@react-pdf/renderer";
import {
  ResumePDFIcon,
  type IconType,
} from "components/Resume/ResumePDF/common/ResumePDFIcon";
import { styles, spacing } from "components/Resume/ResumePDF/styles";

import type { ResumeProfile } from "lib/redux/types";
import { extractUsernameFromURL } from "lib/utils/urlHelpers";
import { TemplateNineProfileSection } from "./common";
import { ResumePDFLink, ResumePDFText } from "../ResumePDF/common";

 const Profile = ({
  profile,
  themeColor,
  isPDF,
}: {
  profile: ResumeProfile;
  themeColor: string;
  isPDF: boolean;
}) => {
  const { name, email, phone, url1, url2, summary, location } = profile;
  const iconProps = {location, email, phone, url1, url2 };

  return (
    <TemplateNineProfileSection style={{ marginTop: spacing["4"] }}>
      <ResumePDFText
        // bold={true}
        themeColor={themeColor}
        style={{
          fontSize: "35pt",
          textAlign: "center",
        }}
      >
        {name}
      </ResumePDFText>
      {/* {summary && (
        <ResumePDFText style={{ textAlign: "center" }}>{summary}</ResumePDFText>
      )} */}
      <View
        style={{
          ...styles.flexRow,
          justifyContent: "center",
          columnGap: 20,
          rowGap: 5,
          flexWrap: "wrap",
          marginTop: spacing["0.5"],
        }}
      >
        {Object.entries(iconProps).map(([key, value]) => {
          if (!value) return null;

          let iconType = key as IconType;
          let displayValue = value;
          if (key === "url1" || key === "url2") {
            if (value.includes("github")) {
              iconType = "url_github";
            } else if (value.includes("linkedin")) {
              iconType = "url_linkedin";
            } else if (value.includes("behance")) {
              iconType = "url_behance";
            } else if (value.includes("dribble")) {
              iconType = "url_dribble";
            }
            displayValue = extractUsernameFromURL(value);
          }

          const shouldUseLinkWrapper = [
            "email",
            "url1",
            "url2",
            "phone",
          ].includes(key);
          const Wrapper = ({ children }: { children: React.ReactNode }) => {
            if (!shouldUseLinkWrapper) return <>{children}</>;

            let src = "";
            switch (key) {
              case "email": {
                src = `mailto:${value}`;
                break;
              }
              case "phone": {
                src = `tel:${value.replace(/[^\d+]/g, "")}`; // Keep only + and digits
                break;
              }
              default: {
                src = value.startsWith("http") ? value : `https://${value}`;
              }
            }

            return (
              <ResumePDFLink src={src} isPDF={isPDF}>
                {children}
              </ResumePDFLink>
            );
          };

          return (
            <View
              key={key}
              style={{
                ...styles.flexRow,
                alignItems: "center",
                gap: spacing["1"],
              }}
            >
              <ResumePDFIcon
                type={iconType}
                isPDF={isPDF}
                themeColor={themeColor}
              />
              <Wrapper>
                {/* <ResumePDFText>{value}</ResumePDFText> */}
                <ResumePDFText>{displayValue}</ResumePDFText>
              </Wrapper>
            </View>
          );
        })}
      </View>
    </TemplateNineProfileSection>
  );
};


export default Profile;